import React from "react"
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import {FilterExpander} from "../common/FilterExpander";
import AssociateFilter from "./AssociateFilter";
const AssociateFilterWrapper = () => {
    const {isMobile} = useDeviceLayout()

    return (
        <React.Fragment>
            {isMobile ?
                <FilterExpander>
                    <AssociateFilter />
                </FilterExpander> :
                <AssociateFilter />}
        </React.Fragment>
    )

}
export default AssociateFilterWrapper


// WEBPACK FOOTER //
// ./src/components/pickassociate/AssociateFilterWrapper.js